"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Orientation = _interopRequireDefault(require("../algorithm/Orientation"));

var _Comparable = _interopRequireDefault(require("../../../../java/lang/Comparable"));

var _ArrayList = _interopRequireDefault(require("../../../../java/util/ArrayList"));

var _Quadrant = _interopRequireDefault(require("../geomgraph/Quadrant"));

var _GraphComponent2 = _interopRequireDefault(require("./GraphComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var DirectedEdge =
/*#__PURE__*/
function (_GraphComponent) {
  _inherits(DirectedEdge, _GraphComponent);

  function DirectedEdge() {
    var _this;

    _classCallCheck(this, DirectedEdge);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DirectedEdge).call(this));
    DirectedEdge.constructor_.apply(_assertThisInitialized(_this), arguments);
    return _this;
  }

  _createClass(DirectedEdge, [{
    key: "isRemoved",
    value: function isRemoved() {
      return this._parentEdge === null;
    }
  }, {
    key: "compareDirection",
    value: function compareDirection(e) {
      if (this._quadrant > e._quadrant) return 1;
      if (this._quadrant < e._quadrant) return -1;
      return _Orientation.default.index(e._p0, e._p1, this._p1);
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      return this._from.getCoordinate();
    }
  }, {
    key: "print",
    value: function print(out) {
      var className = this.getClass().getName();
      var lastDotPos = className.lastIndexOf('.');
      var name = className.substring(lastDotPos + 1);
      out.print("  " + name + ": " + this._p0 + " - " + this._p1 + " " + this._quadrant + ":" + this._angle);
    }
  }, {
    key: "getDirectionPt",
    value: function getDirectionPt() {
      return this._p1;
    }
  }, {
    key: "getAngle",
    value: function getAngle() {
      return this._angle;
    }
  }, {
    key: "compareTo",
    value: function compareTo(obj) {
      var de = obj;
      return this.compareDirection(de);
    }
  }, {
    key: "getFromNode",
    value: function getFromNode() {
      return this._from;
    }
  }, {
    key: "getSym",
    value: function getSym() {
      return this._sym;
    }
  }, {
    key: "setEdge",
    value: function setEdge(parentEdge) {
      this._parentEdge = parentEdge;
    }
  }, {
    key: "remove",
    value: function remove() {
      this._sym = null;
      this._parentEdge = null;
    }
  }, {
    key: "getEdge",
    value: function getEdge() {
      return this._parentEdge;
    }
  }, {
    key: "getQuadrant",
    value: function getQuadrant() {
      return this._quadrant;
    }
  }, {
    key: "setSym",
    value: function setSym(sym) {
      this._sym = sym;
    }
  }, {
    key: "getToNode",
    value: function getToNode() {
      return this._to;
    }
  }, {
    key: "getEdgeDirection",
    value: function getEdgeDirection() {
      return this._edgeDirection;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return DirectedEdge;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_Comparable.default];
    }
  }], [{
    key: "toEdges",
    value: function toEdges(dirEdges) {
      var edges = new _ArrayList.default();

      for (var i = dirEdges.iterator(); i.hasNext();) {
        edges.add(i.next()._parentEdge);
      }

      return edges;
    }
  }]);

  return DirectedEdge;
}(_GraphComponent2.default);

exports.default = DirectedEdge;

DirectedEdge.constructor_ = function () {
  this._parentEdge = null;
  this._from = null;
  this._to = null;
  this._p0 = null;
  this._p1 = null;
  this._sym = null;
  this._edgeDirection = null;
  this._quadrant = null;
  this._angle = null;

  if (arguments.length === 0) {} else if (arguments.length === 4) {
    var from = arguments[0],
        to = arguments[1],
        directionPt = arguments[2],
        edgeDirection = arguments[3];
    this._from = from;
    this._to = to;
    this._edgeDirection = edgeDirection;
    this._p0 = from.getCoordinate();
    this._p1 = directionPt;
    var dx = this._p1.x - this._p0.x;
    var dy = this._p1.y - this._p0.y;
    this._quadrant = _Quadrant.default.quadrant(dx, dy);
    this._angle = Math.atan2(dy, dx);
  }
};